import FeatureView from './FeatureView'

export default FeatureView
